"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconHide = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconHide = function SvgIconHide(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.944 3.367L11.03 2.28A.75.75 0 009.97 1.22L8.69 2.498C7.881 2.05 6.967 1.75 6 1.75c-3.313 0-6 3.514-6 4.5 0 .536.796 1.822 2.057 2.883L.969 10.22a.75.75 0 101.061 1.06l1.279-1.279c.81.449 1.723.749 2.691.749 3.313 0 6-3.515 6-4.5 0-.536-.796-1.823-2.056-2.883zm-2.42.298a3 3 0 00-4.108 4.109L4.55 6.638a1.502 1.502 0 011.837-1.837l1.136-1.136zm-.075 2.196l1.136-1.135a3 3 0 01-4.109 4.108L5.612 7.7A1.502 1.502 0 007.449 5.86z",
    fill: "currentColor"
  }));
};

exports.SvgIconHide = SvgIconHide;